import { render, staticRenderFns } from "./TextSettings.vue?vue&type=template&id=0c11de30&scoped=true&"
import script from "./TextSettings.vue?vue&type=script&lang=js&"
export * from "./TextSettings.vue?vue&type=script&lang=js&"
import style0 from "./TextSettings.vue?vue&type=style&index=0&id=0c11de30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c11de30",
  null
  
)

export default component.exports